import React, {useEffect, useState} from "react";
import {bindActionCreators} from "redux";
import customerActionsImp from "../../../Actions/customerActions";
import {useDispatch, useSelector} from "react-redux";
import { VbAndVossEditForm } from "../../../Utils/customerFormUtils";
import * as formValidationRules from "../../../Constants/formValidationRules";
import useCustomerExpiryDate from "../../../Hooks/Customer/useCustomerExpiryDate";
import useCustomerConnectionsCheck from "../../../Hooks/Customer/useCustomerConnectionsCheck";
import useCustomerFetchAddress from "../../../Hooks/Customer/useCustomerFetchAddress";
import {CustomerForm} from "./CustomerForm";

export const EditVbAndVossCustomerForm = ({}) => {
    const dispatch = useDispatch();
    const customer = useSelector((state) => state.CustomerReducer.customer);
    const customerActions = bindActionCreators(customerActionsImp, dispatch);
    const form = useSelector((state) => state.FormReducer.forms.customerFormData);
    const dropdownLists = useSelector((state) => state.CommonReducer.dropdownlists);
    const { showExpiryDate } = useCustomerExpiryDate(form);
    useCustomerConnectionsCheck(form)
    useCustomerFetchAddress(form);

    const [initialLockState, setInitialLockState] = useState({
        isAddressLocked: false,
        isInvoiceEmailLocked: false
    });

    useEffect(() => {
        if (!form) {
            customerActions.getSelectedCustomerForEdit(customer.vbCustomer?.customerNumber, formValidationRules.VossVbCustomerForm);
        }

    }, []);

    useEffect(() => {
        if (form) {
            setInitialLockState({
                isAddressLocked: form.data.isAddressLocked ?? false,
                isInvoiceEmailLocked: form.data.isInvoiceEmailLocked ?? false
            });
        }
    }, [form?.id]);
    
    if (!form) {
        return null;
    }
    const params = {
        testCustomer: form?.data?.testCustomer,
        showExpiryDate: showExpiryDate,
        isAddressLocked: initialLockState.isAddressLocked,
        isInvoiceEmailLocked: initialLockState.isInvoiceEmailLocked
    };
    
    return <CustomerForm
        columns={VbAndVossEditForm(dropdownLists)}
        form={form}
        fieldParams={params}
    />
}